import "./Products.module.css";
import MainIndustrialHeader from "@/reusable_sections/Header";
import ProductCatalogGrid from "./sections/ProductCatalogGrid";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <MainIndustrialHeader />
      <ProductCatalogGrid />
      <IndustrialFooter />
    </div>;
}